import { useEffect, useState } from "react";
import loginLogo from "../../assets/logiscreen.png";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";
import { toast } from "react-toastify";
import ForgotPassword from "../CreateAccount/ForgotPassword";
import {
  detectLogin,
  setUserdatas,
  showToast,
} from "../../helper/generalHelper";
import { FiEye, FiEyeOff } from "react-icons/fi";

const StaffLoginScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // detectLogin(); // Removed as per user request to stop 'automation'
  }, []);

  const [loginData, setLoginData] = useState({
    email_or_mobile: "",
    password: "",
  });

  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    if (!loginData.email_or_mobile.trim()) {
      setError("Email or mobile number is required");
      setLoading(false);
      return;
    }

    if (!loginData.password.trim()) {
      setError("Password is required");
      setLoading(false);
      return;
    }

    const res = await api.post("restaurant/staff-login", {
      email_or_mobile: loginData.email_or_mobile,
      password: loginData.password
    }, {}, false);

    showToast(res);
    setLoading(false);

    if (res.success || res.data?.is_authenticated) {
      setUserdatas(res?.data);
      setSuccess("Login successful!");
      
      setTimeout(() => {
        // Unconditionally route to profile first for all staff logins
        navigate("/restaurant-staff/employee/profile");
      }, 1000);
    } else {
      setError(res.message || "Login failed. Please check your credentials.");
    }
  };

  return (
    <div className="h-screen w-screen overflow-scroll bg-white md:bg-white">
      {/* ✅ Desktop View */}
      <div className="hidden md:flex flex-row items-center justify-center h-screen p-8 bg-white">
        <div className="md:w-1/2 w-full md:flex justify-center items-center">
          <img src={loginLogo} alt="Illustration" className="md:w-3/4" />
        </div>

        <div className="w-full md:w-1/2 max-w-md">
          <div className="rounded-lg shadow-md p-8">
            <h2 className="text-2xl font-bold mb-6 text-center">Staff Login</h2>

            {error && (
              <p className="text-red-500 text-center mb-4 bg-red-50 p-3 rounded">
                {error}
              </p>
            )}
            {success && (
              <p className="text-green-600 text-center mb-4 bg-green-50 p-3 rounded">
                {success}
              </p>
            )}

            <form onSubmit={handleLoginSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email or Mobile Number
                </label>
                <input
                  type="text"
                  name="email_or_mobile"
                  placeholder="example@email.com or 9876543210"
                  value={loginData.email_or_mobile}
                  onChange={handleLoginChange}
                  autoComplete="off"
                  className="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Enter your password"
                    value={loginData.password}
                    onChange={handleLoginChange}
                    autoComplete="new-password"
                    className="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                  >
                    {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                  </button>
                </div>
              </div>

              <div className="text-right">
                <button
                  type="button"
                  onClick={() => setIsForgotPasswordOpen(true)}
                  className="text-primary hover:opacity-80 text-sm font-semibold"
                >
                  Forgot Password?
                </button>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-primary disabled:bg-gray-400 text-white font-semibold py-3 rounded-lg transition hover:opacity-90"
              >
                {loading ? "Logging in..." : "Login"}
              </button>
            </form>

            <p className="text-center text-gray-600 text-sm mt-6">
              Not a staff member yet? Contact your admin to create an account.
            </p>
          </div>
        </div>
      </div>

      {/* ✅ Mobile View */}
      <div className="md:hidden min-h-screen bg-white flex flex-col">
        <div className="flex-1 flex flex-col items-center justify-center px-4 py-8">
          <img src={loginLogo} alt="Illustration" className="w-3/4 mb-8" />

          <div className="w-full max-w-sm">
            <h2 className="text-2xl font-bold mb-6 text-center">Staff Login</h2>

            {error && (
              <p className="text-red-500 text-center mb-4 bg-red-50 p-3 rounded">
                {error}
              </p>
            )}
            {success && (
              <p className="text-green-600 text-center mb-4 bg-green-50 p-3 rounded">
                {success}
              </p>
            )}

            <form onSubmit={handleLoginSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email or Mobile Number
                </label>
                <input
                  type="text"
                  name="email_or_mobile"
                  placeholder="example@email.com or 9876543210"
                  value={loginData.email_or_mobile}
                  onChange={handleLoginChange}
                  autoComplete="off"
                  className="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Enter your password"
                    value={loginData.password}
                    onChange={handleLoginChange}
                    autoComplete="new-password"
                    className="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                  >
                    {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
                  </button>
                </div>
              </div>

              <div className="text-right">
                <button
                  type="button"
                  onClick={() => setIsForgotPasswordOpen(true)}
                  className="text-primary hover:opacity-80 text-sm font-semibold"
                >
                  Forgot Password?
                </button>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-primary disabled:bg-gray-400 text-white font-semibold py-3 rounded-lg transition hover:opacity-90"
              >
                {loading ? "Logging in..." : "Login"}
              </button>
            </form>

            <p className="text-center text-gray-600 text-sm mt-6">
              Not a staff member yet? Contact your admin to create an account.
            </p>
          </div>
        </div>
      </div>

      <ForgotPassword 
        isOpen={isForgotPasswordOpen}
        onClose={() => setIsForgotPasswordOpen(false)}
        userType="staff"
      />
    </div>
  );
};

export default StaffLoginScreen;
